export default function RepairNotReplace() {
  return (
    <section className="bg-plum py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-white mb-4 md:mb-6">
            Réparer plutôt que remplacer la fenêtre
          </h2>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto">
            Une fenêtre PVC ne s'use pas en profilé : elle s'use en mécanisme. Changer une fenêtre entière coûte cher et représente un chantier lourd. Chez DF PRO, nous remplaçons uniquement la pièce usée, le crémone, la poignée ou le gond. Vous gardez votre cadre PVC, votre vitrage et votre esthétique. C'est plus rapide, plus économique et plus écologique.
          </p>
          <a
            href="tel:0374471036"
            className="inline-flex items-center justify-center gap-2 bg-coral text-white px-8 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}